import { Box } from "@mui/material";
import { PokemonType } from "../../types/type";
import { PokemonDefenceInterface } from "../../pokemon/pokemon";
import TeraTypeSelect from "../../components/TeraTypeSelect";

interface InputTerasuProps {
  selectedPokemon: PokemonDefenceInterface;
  setSelectedPokemon: React.Dispatch<React.SetStateAction<PokemonDefenceInterface | null>>;
}

function InputTerasu({ selectedPokemon, setSelectedPokemon }: InputTerasuProps) {
  return (
    <Box>
      <TeraTypeSelect
        value={selectedPokemon?.terasu_type}
        onChange={(value) => {
          if (selectedPokemon) {
            const updatedPokemon = { ...selectedPokemon };
            updatedPokemon.terasu_type = value === 0 ? undefined : value as PokemonType;
            setSelectedPokemon(updatedPokemon);
          }
        }}
        variant="sidebar"
        label="テラスタイプを選択"
      />
    </Box>
  );
}

export default InputTerasu;
